// A function that takes a CompEvent and SocketResultMessagePayloadSeedDropped
// and returns a new CompEvent with any values from the SocketResultMessagePayloadSeedDropped.heatInfo message applied
// to the CompEvent.entries
import { simpleClone } from '@/services/common-service-utils'
import type { CompEvent } from '@/components/results/store-comp-results'
import type {
  SocketResultMessagePayloadSeedDropped,
  SocketResultMessagePayloadSeedDroppedAthlete
} from '@/components/results/socket/seed-dropped/models/seed-dropped'

export function updateSeedDropped(
  compEvent: CompEvent,
  payload: SocketResultMessagePayloadSeedDropped
): CompEvent {
  const compEventInternal = simpleClone(compEvent)

  if (!compEventInternal.entries) {
    return compEventInternal
  }

  // create a map by athleteId

  const athletes: SocketResultMessagePayloadSeedDroppedAthlete[] = payload

  // Create a map of athleteId to athleteId for quick lookup.
  // Guard against entries missing an `athleteId` (sometimes undefined in
  // malformed socket payloads) which previously threw
  // "Cannot read properties of undefined (reading 'toString')" — see
  // Sentry LITECLIENT-Q.
  const athleteIdMap: Record<string, SocketResultMessagePayloadSeedDroppedAthlete> = {}
  athletes.forEach((athlete: SocketResultMessagePayloadSeedDroppedAthlete) => {
    if (athlete?.athleteId == null) {
      return
    }
    athleteIdMap[athlete.athleteId.toString()] = athlete
  })

  // Loop through the entries and update the seeding
  for (const athleteId in compEventInternal.entries) {
    const entry = compEventInternal.entries[athleteId]
    const athlete = athleteIdMap[athleteId]
    if (!athlete) {
      continue
    }
    if (entry.athleteId === athlete.athleteId) {
      entry.seeding.heatNo = athlete.heatInfo.heatNo
      entry.seeding.laneNo = athlete.heatInfo.laneNo
    }
  }

  return compEventInternal
}
